<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <div>{{ 'Confirmation.Title' | translate }}</div>
  <button type="button" mat-icon-button (click)="close(false)" tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p style="white-space: pre-line;">{{ message | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close(false)">{{ 'Confirmation.No' | translate }}</button>
  <button mat-button color="primary" (click)="close(true)">{{ 'Confirmation.Yes' | translate }}</button>
</mat-dialog-actions>
